/* ============================================================
   Regulatory glossary — searchable, linked to the register.
   ============================================================ */

import { searchGlossary } from '../../data/glossary.js';
import { getRegulation, statusOf, STATUS_META } from '../../data/regulations.js';
import { html } from '../../shared/html.js';

export function GlossaryPage() {
  const page = document.createElement('div');
  page.className = 'container-narrow page animate-fade-in';

  page.innerHTML = html`
    <header class="page-head">
      <h1>Regulatory Glossary</h1>
      <p>The acronyms that appear on your paperwork, and the instruments behind them.</p>
    </header>

    <label class="field">
      <span class="sr-only">Search the glossary</span>
      <input
        id="glossary-search"
        class="input-field"
        type="search"
        placeholder="Search terms, e.g. demurrage or ACD"
        autocomplete="off"
      />
    </label>

    <div id="glossary-results" class="stack" style="margin-top: var(--ca-space-4);"></div>
  `;

  const input = page.querySelector('#glossary-search');
  const results = page.querySelector('#glossary-results');

  const paint = () => {
    const entries = searchGlossary(input.value);
    results.replaceChildren();

    if (entries.length === 0) {
      results.innerHTML = html`
        <div class="empty-state">
          <h3>Nothing matches “${input.value}”</h3>
          <p>Try a shorter term, or clear the search to browse all entries.</p>
        </div>
      `;
      return;
    }

    for (const entry of entries) results.appendChild(termCard(entry));
  };

  input.addEventListener('input', paint);
  paint();

  return page;
}

function termCard(entry) {
  const card = document.createElement('article');
  card.className = 'card';

  const linked = (entry.related || [])
    .map((id) => getRegulation(id))
    .filter(Boolean)
    .map((reg) => ({ reg, status: statusOf(reg) }));

  card.innerHTML = html`
    <div class="row" style="align-items: baseline; gap: var(--ca-space-2); margin-bottom: var(--ca-space-1);">
      <h3 style="font-size: var(--ca-text-base);">${entry.key}</h3>
      <span style="font-size: var(--ca-text-sm); color: var(--ca-text-tertiary);">${entry.term}</span>
    </div>
    <p style="font-size: var(--ca-text-sm); color: var(--ca-text-secondary);">${entry.definition}</p>
    <div class="row" style="flex-wrap: wrap; gap: var(--ca-space-2); margin-top: var(--ca-space-3);">
      <span class="chip">${entry.authority}</span>
      ${linked.map(
        ({ reg, status }) => html`<span class="chip">${reg.name} · ${STATUS_META[status].label}</span>`
      )}
    </div>
  `;

  return card;
}
